/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-08-21 15:05:16
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 15:00:04
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLargeModelSecurity.js
 * @Description: 大模型安全风控解决方案
 */
import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageLargeModelSecurity.less';


const PageCommercialPassword = props => {
    const bannerInfo = props.bannerInfo || {};
    const learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};

    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={'商务咨询'}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
                {bannerInfo.learnMore.length
                    ? bannerInfo.learnMore.length === 1
                        ? bannerInfo.nextIndex === '0'
                            ? (<a href={learnMoreItem.content} target="_blank"
                                className="compliance-btn compliance-btn-border">
                                {learnMoreItem.title}
                            </a>) : (<a
                                href={learnMoreItem.content}
                                target="_blank"
                                className="compliance-btn compliance-btn-border"
                            >
                                {learnMoreItem.title}
                            </a>) : (<div className={'about-tab'}>
                            <div className={'about-slide'}>
                                <ul>
                                    {
                                        learnMore.map((item, index) => {
                                            return <li key={index}>
                                                <a href={item.content} target={'_blank'}>{item.title}</a>
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={'tab-shadow'} />
                        </div>) : null}

            </div>
            <div className={'product-des'}>
                全自动模拟真实网络钓鱼场景开展攻防演练，助力企业检验人员安全防范能力，搭配多样化安全宣传与活动，全面且深入地提升企业人员安全认知，为企业筑牢人员安全防线提供有力支撑。
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'业务挑战'} />
                </div>
                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>网络安全威胁不断</div>
                            <div className={'profun-box-des'}>
                                全球网络攻击事件数量逐年攀升，勒索软件、钓鱼攻击、数据泄露等威胁手段层出不穷。攻击手段迭代快，精准瞄准人员漏洞。传统技术防护难全面拦截，易引发数据泄露、系统瘫痪等风险。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>网安立法逐步完善</div>
                            <div className={'profun-box-des'}>
                                《数据安全法》《个保法》等法规明确企业责任，监管检查频次增加。若人员操作不合规，企业易面临高额罚款、业务暂停等严重后果，合规压力剧增。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>人员安全意识薄弱</div>
                            <div className={'profun-box-des'}>
                                员工普遍存在弱密码、违规传数据等行为，安全培训多流于形式，难以转化为实际防护能力，人员短板成企业安全防线的主要突破口。
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className={'product-mod'}>
                    <ProductTitle title={'方案介绍'} />
                </div>
                <div>
                    <img src={require('../../asset/image/pageSecAwarenrssSolution/plan.png')} alt=""
                        width={'95%'} height={'175px'}
                        style={{margin: '0 auto'}} />
                </div>
            </div>


            <div>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="核心服务" />
                </div>
                <div className="programme-box">
                    <div className="saas-p-case-title">钓鱼演练平台</div>
                    <img
                        width={'100%'}
                        className="programme-box-img"
                        src={require('../../asset/image/pageSecAwarenrssSolution/fish.png')} alt="钓鱼演练平台"
                    />
                </div>
                <div className="programme-box">
                    <div className="saas-p-case-title">人员安全培训</div>
                    <img
                        width={'100%'}
                        className="programme-box-img"
                        src={require('../../asset/image/pageSecAwarenrssSolution/train.png')} alt="人员安全培训"
                    />
                </div>
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'} />
                </div>
                <div className={'product-mod'} style={{paddingBottom: 0}}>
                    {
                        [
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_1_wap.png'),
                                title: '安全培训',
                                // eslint-disable-next-line max-len
                                content: '适用于新员工入职、全体员工及年度安全能力提升，通过线上课程 + 线下专家课，覆盖各类安全风险、钓鱼攻击识别等知识，帮员工快速建立安全认知，适配企业全员覆盖需求。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_2_wap.png'),
                                title: '安全演练',
                                content: '常态化演练适配日常风险防控，如每月钓鱼测试；专项演练应对特殊场景，如数据泄露应急。通过模拟实战，提升员工风险处置能力，降低真实事故损失。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_3_wap.png'),
                                title: '安全活动',
                                content: '适合企业安全宣传周、季度宣贯等节点，线上设知识挑战赛，线下落地互动展，以趣味形式强化安全记忆，营造全员参与的安全文化氛围，补足传统培训趣味性短板。'
                            },
                        ].map((item, index) => {
                            return <div
                                className={'pro-applicable'}
                                key={index}
                                style={{backgroundImage: `url(${item.mobile_pic})`}}
                            >
                                <div className={'pro-app-title'}>
                                    {item.title}
                                </div>
                                <div className={'pro-app-content'}>
                                    {item.content}
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>

            <div>
                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="核心优势" />
                </div>
                <div className="saas-p-advantage">
                    {
                        [
                            {
                                title: '专业性',
                                des: '立足甲方防护思维，凭借多年攻防经验，融入大模型 AI 技术，精准洞察人员安全风险，提升方案针对性与防护有效性。',
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_zhuanye.svg')
                            },
                            {
                                title: '完整性',
                                des: '依托百度安全大模型实践总结，从员工全生命周期出发，覆盖钓鱼演练、安全培训、意识考核、AI 钓鱼等关键阶段，形成闭环保障。',
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_wanzheng.svg')
                            },
                            {
                                title: '多样性',
                                des: '提供方案、内容输出、活动落地等多类培训场景，涵盖云上精调、私有化共建、安全咨询等服务，适配企业不同需求。',
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_duoyang.svg')
                            },
                            {
                                title: '创新性',
                                // eslint-disable-next-line max-len
                                des: '打破传统培训枯燥感，设线上挑战赛、模拟黑客捕鱼达人、CTF 挑战赛、逻辑推理游戏，线下开展钓鱼互动、迷宫探险、黑客追击者等，让员工在趣味互动中掌握安全知识，实现寓教于乐。',
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_chuangxin.svg')
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-p-advantage-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.url})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des">{item.des}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageCommercialPassword.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageCommercialPassword;



// WEBPACK FOOTER //
// ./src/containers/product/pageSecAwarenrssSolution.js